var _style, _path, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_458",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 429 241.3",
    style: {
      enableBackground: "new 0 0 429 241.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.disconnect0{fill:#6C717C;}\n\t.disconnect1{clip-path:url(#SVGID_00000107572944816241403220000015265526567527843225_);}\n\t.disconnect2{fill:#474B51;}\n\t.disconnect3{fill:#97999B;}\n\t.disconnect4{fill:#FDCBC7;}\n\t.disconnect5{fill:#FFF3F3;}\n\t.disconnect6{fill:#F0ACAE;}\n\t.disconnect7{fill:#E49195;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1850",
    className: "disconnect0",
    d: "M0,176.2l123.8,16.3l0.5-3.5l-2.5-0.3L125,164l23,3l3.1-23.3l18.8,2.5l3-22.9l16.2,2.1l3-22.6 l-13.3-1.7l3-22.7l6.6,0.9l3.8-29.1L19.5,27.5L0,176.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_457"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 429,
    height: 241.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049924404065061158850000003267109519386587321_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_456",
    style: {
      clipPath: "url(#SVGID_00000049924404065061158850000003267109519386587321_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1851",
    className: "disconnect2",
    d: "M41.5,80.7c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L41.5,80.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1852",
    className: "disconnect2",
    d: "M64.2,83.7c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L64.2,83.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1853",
    className: "disconnect2",
    d: "M86.9,86.7c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2c0,0,0,0,0,0l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L86.9,86.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1854",
    className: "disconnect2",
    d: "M109.7,89.7c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L109.7,89.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1855",
    className: "disconnect2",
    d: "M132.4,92.6c-0.1,1-1,1.7-2,1.6l-17-2.2c-1-0.1-1.7-1-1.6-2c0,0,0,0,0,0l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2L132.4,92.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1856",
    className: "disconnect2",
    d: "M155.1,95.6c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L155.1,95.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1857",
    className: "disconnect2",
    d: "M177.8,98.6c-0.1,1-1,1.7-2,1.6l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17c0.1-1,1-1.7,2-1.6 c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L177.8,98.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234",
    className: "disconnect2",
    d: "M24,54.5l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C24.7,56.9,23.9,55.8,24,54.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235",
    className: "disconnect2",
    d: "M47.8,57.6l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C48.5,60.1,47.6,58.9,47.8,57.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236",
    className: "disconnect2",
    d: "M71.5,60.8l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l15.9,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2l-15.9-2.1C72.3,63.2,71.4,62,71.5,60.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237",
    className: "disconnect2",
    d: "M95.3,63.9l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C96,66.3,95.1,65.1,95.3,63.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_238",
    className: "disconnect2",
    d: "M119.1,67l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6c0,0,0,0,0,0 l-0.9,6.6c-0.2,1.3-1.3,2.2-2.6,2l-16-2.1C119.8,69.4,118.9,68.3,119.1,67z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_239",
    className: "disconnect2",
    d: "M142.8,70.1l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C143.5,72.5,142.7,71.4,142.8,70.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_240",
    className: "disconnect2",
    d: "M166.6,73.2l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C167.3,75.7,166.4,74.5,166.6,73.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1858",
    className: "disconnect2",
    d: "M167.8,120.2c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L167.8,120.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1859",
    className: "disconnect2",
    d: "M145,117.2c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6c0,0,0,0,0,0L145,117.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1860",
    className: "disconnect2",
    d: "M122.3,114.3c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L122.3,114.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1861",
    className: "disconnect2",
    d: "M99.6,111.3c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L99.6,111.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1862",
    className: "disconnect2",
    d: "M76.9,108.3c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L76.9,108.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1863",
    className: "disconnect2",
    d: "M54.1,105.3c-0.1,1,0.6,1.9,1.6,2l17,2.2c1,0.1,1.9-0.6,2-1.5c0,0,0,0,0,0l2.2-17 c0.1-1-0.6-1.9-1.6-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L54.1,105.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1864",
    className: "disconnect2",
    d: "M18,100.6c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l30.4,4c1,0.1,1.9-0.6,2-1.6l2.2-17 c0.1-1-0.6-1.9-1.6-2l-30.4-4c-1-0.1-1.9,0.6-2,1.6L18,100.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1865",
    className: "disconnect2",
    d: "M148.5,141c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L148.5,141z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1866",
    className: "disconnect2",
    d: "M125.8,138c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L125.8,138z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1867",
    className: "disconnect2",
    d: "M103.1,135c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-16.9-2.2c-1-0.1-1.9,0.6-2,1.6L103.1,135z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1868",
    className: "disconnect2",
    d: "M80.4,132.1c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.5c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L80.4,132.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1869",
    className: "disconnect2",
    d: "M57.6,129.1c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L57.6,129.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1870",
    className: "disconnect2",
    d: "M15,123.5c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l36.9,4.8c1,0.1,1.9-0.6,2-1.5c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.6-2L19.2,105c-1-0.1-1.9,0.6-2,1.6L15,123.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1871",
    className: "disconnect2",
    d: "M126.5,161.4c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L126.5,161.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1872",
    className: "disconnect2",
    d: "M103.8,158.4c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L103.8,158.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1873",
    className: "disconnect2",
    d: "M81,155.4c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L81,155.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1874",
    className: "disconnect2",
    d: "M58.3,152.4c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l16.9,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L58.3,152.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1875",
    className: "disconnect2",
    d: "M12,146.3c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l40.6,5.3c1,0.1,1.9-0.6,2-1.5c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.6-2c0,0,0,0,0,0l-40.6-5.3c-1-0.1-1.9,0.6-2,1.6L12,146.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1876",
    className: "disconnect2",
    d: "M77.1,178.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l40.6,5.3c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0L81.3,160c-1-0.1-1.9,0.6-2,1.6L77.1,178.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1877",
    className: "disconnect2",
    d: "M54.4,175.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L54.4,175.5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1878",
    className: "disconnect2",
    d: "M31.6,172.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L31.6,172.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1879",
    className: "disconnect2",
    d: "M8.9,169.6c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L8.9,169.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1880",
    className: "disconnect3",
    d: "M41.6,79.9c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l16.9,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L41.6,79.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1881",
    className: "disconnect3",
    d: "M64.3,82.9c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L64.3,82.9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1882",
    className: "disconnect3",
    d: "M87,85.9c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L87,85.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1883",
    className: "disconnect3",
    d: "M132.5,91.9c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L132.5,91.9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1884",
    className: "disconnect3",
    d: "M155.2,94.8c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L155.2,94.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1885",
    className: "disconnect3",
    d: "M177.9,97.8c-0.1,1-1,1.7-2,1.6c0,0,0,0,0,0l-17-2.2c-1-0.1-1.7-1-1.6-2l2.2-17 c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0l17,2.2c1,0.1,1.7,1,1.6,2c0,0,0,0,0,0L177.9,97.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_241",
    className: "disconnect3",
    d: "M24.1,53.7l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6c0,0,0,0,0,0 l-0.9,6.6c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C24.8,56.2,24,55,24.1,53.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_242",
    className: "disconnect3",
    d: "M47.9,56.9l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C48.6,59.3,47.7,58.1,47.9,56.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_243",
    className: "disconnect3",
    d: "M71.6,60l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6c0,0,0,0,0,0 l-0.9,6.6c-0.2,1.3-1.3,2.2-2.6,2l-16-2.1C72.4,62.4,71.5,61.3,71.6,60z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_244",
    className: "disconnect3",
    d: "M95.4,63.1l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C96.1,65.5,95.2,64.4,95.4,63.1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_245",
    className: "disconnect3",
    d: "M119.2,66.2l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6c0,0,0,0,0,0 l-0.9,6.6c-0.2,1.3-1.3,2.2-2.6,2c0,0,0,0,0,0l-16-2.1C119.9,68.7,119,67.5,119.2,66.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_246",
    className: "disconnect3",
    d: "M142.9,69.3l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l15.9,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2l-15.9-2.1C143.6,71.8,142.8,70.6,142.9,69.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_247",
    className: "disconnect3",
    d: "M166.7,72.5l0.9-6.6c0.2-1.3,1.3-2.2,2.6-2l16,2.1c1.3,0.2,2.2,1.3,2,2.6l-0.9,6.6 c-0.2,1.3-1.3,2.2-2.6,2l-16-2.1C167.4,74.9,166.5,73.7,166.7,72.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1886",
    className: "disconnect3",
    d: "M167.9,119.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L167.9,119.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1887",
    className: "disconnect3",
    d: "M145.1,116.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L145.1,116.5z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1888",
    className: "disconnect3",
    d: "M122.4,113.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6l2.2-17 c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L122.4,113.5z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1889",
    className: "disconnect3",
    d: "M99.7,110.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L99.7,110.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1890",
    className: "disconnect3",
    d: "M77,107.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L77,107.5z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1891",
    className: "disconnect3",
    d: "M54.2,104.5c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L54.2,104.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1892",
    className: "disconnect3",
    d: "M18.1,99.8c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l30.4,4c1,0.1,1.9-0.6,2-1.6l2.2-17 c0.1-1-0.6-1.9-1.6-2l-30.4-4c-1-0.1-1.9,0.6-2,1.6L18.1,99.8z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1893",
    className: "disconnect3",
    d: "M148.6,140.2c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L148.6,140.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1894",
    className: "disconnect3",
    d: "M125.9,137.3c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.5c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.6-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L125.9,137.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1895",
    className: "disconnect3",
    d: "M103.2,134.3c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L103.2,134.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1896",
    className: "disconnect3",
    d: "M80.5,131.3c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L80.5,131.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1897",
    className: "disconnect3",
    d: "M57.7,128.3c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6l2.2-17 c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L57.7,128.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1898",
    className: "disconnect3",
    d: "M15.1,122.7c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l36.9,4.8c1,0.1,1.9-0.6,2-1.5c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.6-2l-36.9-4.8c-1-0.1-1.9,0.6-2,1.6L15.1,122.7z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1899",
    className: "disconnect3",
    d: "M103.9,157.6c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L103.9,157.6z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1900",
    className: "disconnect3",
    d: "M81.1,154.6c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L81.1,154.6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1901",
    className: "disconnect3",
    d: "M58.4,151.6c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L58.4,151.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1902",
    className: "disconnect3",
    d: "M12.1,145.6c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l40.6,5.3c1,0.1,1.9-0.6,2-1.5c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.6-2c0,0,0,0,0,0L16.3,127c-1-0.1-1.9,0.6-2,1.6L12.1,145.6z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1903",
    className: "disconnect3",
    d: "M77.2,177.7c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l40.6,5.3c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-40.6-5.3c-1-0.1-1.9,0.6-2,1.6L77.2,177.7z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1904",
    className: "disconnect3",
    d: "M54.5,174.7c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0 l2.2-17c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L54.5,174.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1905",
    className: "disconnect3",
    d: "M31.7,171.8c-0.1,1,0.6,1.9,1.5,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6l2.2-17 c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L31.7,171.8z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1906",
    className: "disconnect3",
    d: "M9,168.8c-0.1,1,0.6,1.9,1.6,2c0,0,0,0,0,0l17,2.2c1,0.1,1.9-0.6,2-1.6c0,0,0,0,0,0l2.2-17 c0.1-1-0.6-1.9-1.5-2c0,0,0,0,0,0l-17-2.2c-1-0.1-1.9,0.6-2,1.6L9,168.8z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1907",
    className: "disconnect0",
    d: "M408.2,35.8L235.8,59.9l4.1,29.1l-6.6,0.9l3.2,22.6l13.2-1.9l3.2,22.5l-16.2,2.3l3.2,22.9 L221,161l3.3,23.3l-27,3.8l3.4,24.6l3.4-0.5l0.5,3.5L429,184.3L408.2,35.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_248",
    className: "disconnect2",
    d: "M242.8,76.4l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6l-15.9,2.2 c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C240.7,77.7,241.6,76.5,242.8,76.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_249",
    className: "disconnect2",
    d: "M266.6,73l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0,0l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6l0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C264.4,74.4,265.3,73.2,266.6,73z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_250",
    className: "disconnect2",
    d: "M290.3,69.7l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0,0l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6l0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C288.1,71.1,289,69.9,290.3,69.7z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_251",
    className: "disconnect2",
    d: "M314,66.4l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0,0l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6l0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C311.9,67.7,312.8,66.6,314,66.4z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_252",
    className: "disconnect2",
    d: "M337.8,63.1l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0,0l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6l0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C335.6,64.4,336.5,63.2,337.8,63.1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_253",
    className: "disconnect2",
    d: "M361.5,59.7l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6c0,0,0,0,0,0 L363,70.9c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C359.3,61.1,360.2,59.9,361.5,59.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_254",
    className: "disconnect2",
    d: "M385.2,56.4l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0,0l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6l0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C383.1,57.8,384,56.6,385.2,56.4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1908",
    className: "disconnect2",
    d: "M258.3,107.1c0.1,1-0.5,1.9-1.5,2c0,0,0,0,0,0l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L258.3,107.1z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1909",
    className: "disconnect2",
    d: "M281,104c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.5-1.9,1.5-2c0,0,0,0,0,0l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L281,104z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1910",
    className: "disconnect2",
    d: "M303.7,100.8c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L303.7,100.8z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1911",
    className: "disconnect2",
    d: "M326.4,97.6c0.1,1-0.6,1.9-1.5,2L308,102c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L326.4,97.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1912",
    className: "disconnect2",
    d: "M349.1,94.4c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.5-1.9,1.5-2c0,0,0,0,0,0l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L349.1,94.4z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1913",
    className: "disconnect2",
    d: "M371.8,91.2c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0L349,77.2 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L371.8,91.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1914",
    className: "disconnect2",
    d: "M408,86.2c0.1,1-0.6,1.9-1.5,2l-30.3,4.2c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0L371.7,74 c-0.1-1,0.6-1.9,1.5-2l30.3-4.2c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L408,86.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1915",
    className: "disconnect2",
    d: "M206.3,207.7c0.1,1,1.1,1.7,2,1.5L316.8,194c1-0.1,1.7-1.1,1.5-2L316,175 c-0.1-1-1-1.7-2-1.5c0,0,0,0,0,0l-108.5,15.2c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L206.3,207.7z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1916",
    className: "disconnect2",
    d: "M320.5,191.7c0.1,1,1.1,1.7,2,1.5l24.8-3.5c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-24.8,3.5c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L320.5,191.7z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1917",
    className: "disconnect2",
    d: "M351.1,187.4c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L351.1,187.4z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_255",
    className: "disconnect2",
    d: "M374.9,175.4l10.3-1.4c1.3-0.2,2.4,0.7,2.6,2l0.8,5.7c0.2,1.3-0.7,2.4-2,2.6l-10.3,1.4 c-1.3,0.2-2.4-0.7-2.6-2l-0.8-5.7C372.8,176.8,373.6,175.6,374.9,175.4z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_256",
    className: "disconnect2",
    d: "M390.9,173.2l10.3-1.4c1.3-0.2,2.4,0.7,2.6,2l0.8,5.7c0.2,1.3-0.7,2.4-2,2.6l-10.3,1.4 c-1.3,0.2-2.4-0.7-2.6-2l-0.8-5.7C388.8,174.5,389.7,173.3,390.9,173.2z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1918",
    className: "disconnect2",
    d: "M388.3,171.1c0.2,0.9,1.1,1.6,2,1.4l11.3-1.6c1-0.1,1.7-1,1.6-1.9l-0.9-6.2 c-0.2-0.9-1.1-1.6-2-1.4L389,163c-1,0.1-1.7,1-1.6,1.9L388.3,171.1z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_257",
    className: "disconnect2",
    d: "M407,170.9l10.3-1.4c1.3-0.2,2.4,0.7,2.6,2l0.8,5.7c0.2,1.3-0.7,2.4-2,2.6l-10.3,1.4 c-1.3,0.2-2.4-0.7-2.6-2l-0.8-5.7C404.8,172.3,405.7,171.1,407,170.9z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1919",
    className: "disconnect2",
    d: "M406.7,90.2l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0l2.4,16.9c0.1,1,1.1,1.7,2,1.5 l4.7-0.7l3,21.1c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l10.4-1.5c1-0.1,1.7-1.1,1.5-2l-3.2-22.9l-0.5-3.9l-1.8-13 C408.6,90.8,407.7,90.1,406.7,90.2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1920",
    className: "disconnect2",
    d: "M367.9,114.8c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l16.9-2.4c1-0.1,1.7-1.1,1.5-2L386,95 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L367.9,114.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1921",
    className: "disconnect2",
    d: "M345.2,117.9c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5L344.4,99c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L345.2,117.9z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1922",
    className: "disconnect2",
    d: "M322.5,121.1c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L322.5,121.1z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1923",
    className: "disconnect2",
    d: "M299.8,124.3c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L299.8,124.3z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1924",
    className: "disconnect2",
    d: "M277.1,127.5c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L277.1,127.5z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1925",
    className: "disconnect2",
    d: "M254.4,130.6c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L254.4,130.6z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1926",
    className: "disconnect2",
    d: "M332.2,143.1c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L332.2,143.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1927",
    className: "disconnect2",
    d: "M354.9,139.9c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L354.9,139.9z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1928",
    className: "disconnect2",
    d: "M377.6,136.7c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L377.6,136.7z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1929",
    className: "disconnect2",
    d: "M309.5,146.3c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L309.5,146.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1930",
    className: "disconnect2",
    d: "M286.8,149.5c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L286.8,149.5z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1931",
    className: "disconnect2",
    d: "M264.1,152.6c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L264.1,152.6z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1932",
    className: "disconnect2",
    d: "M241.4,155.8c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L241.4,155.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1933",
    className: "disconnect2",
    d: "M361.8,162.2c0.1,1,1.1,1.7,2,1.5l52.1-7.3c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1-1.7-2-1.5c0,0,0,0,0,0l-52.1,7.3c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L361.8,162.2z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1934",
    className: "disconnect2",
    d: "M339.1,165.4c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L339.1,165.4z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1935",
    className: "disconnect2",
    d: "M316.4,168.6c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L316.4,168.6z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1936",
    className: "disconnect2",
    d: "M293.7,171.8c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L293.7,171.8z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1937",
    className: "disconnect2",
    d: "M271,174.9c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L271,174.9z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1938",
    className: "disconnect2",
    d: "M248.3,178.1c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L248.3,178.1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1939",
    className: "disconnect2",
    d: "M225.6,181.3c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L225.6,181.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_258",
    className: "disconnect3",
    d: "M242.7,75.6l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6c0,0,0,0,0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C240.6,76.9,241.4,75.8,242.7,75.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_259",
    className: "disconnect3",
    d: "M266.4,72.3l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6c0,0,0,0,0,0 L268,83.4c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C264.3,73.6,265.2,72.4,266.4,72.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_260",
    className: "disconnect3",
    d: "M290.2,68.9l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0,0l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6l0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C288,70.3,288.9,69.1,290.2,68.9z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_261",
    className: "disconnect3",
    d: "M313.9,65.6l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6c0,0,0,0,0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C311.8,67,312.6,65.8,313.9,65.6z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_262",
    className: "disconnect3",
    d: "M337.6,62.3l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6c0,0,0,0,0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C335.5,63.6,336.4,62.5,337.6,62.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_263",
    className: "disconnect3",
    d: "M361.4,59l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6c0,0,0,0,0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C359.2,60.3,360.1,59.1,361.4,59z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_264",
    className: "disconnect3",
    d: "M385.1,55.6l15.9-2.2c1.3-0.2,2.4,0.7,2.6,2l0.9,6.6c0.2,1.3-0.7,2.4-2,2.6c0,0,0,0,0,0 l-15.9,2.2c-1.3,0.2-2.4-0.7-2.6-2l-0.9-6.6C383,57,383.8,55.8,385.1,55.6z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1940",
    className: "disconnect3",
    d: "M258.2,106.4c0.1,1-0.5,1.9-1.5,2c0,0,0,0,0,0l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L258.2,106.4z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1941",
    className: "disconnect3",
    d: "M280.9,103.2c0.1,1-0.5,1.9-1.5,2c0,0,0,0,0,0l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0 l-2.4-16.9c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L280.9,103.2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1942",
    className: "disconnect3",
    d: "M303.6,100c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L303.6,100z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1943",
    className: "disconnect3",
    d: "M326.3,96.8c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L326.3,96.8z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1944",
    className: "disconnect3",
    d: "M349,93.6c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L349,93.6z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1945",
    className: "disconnect3",
    d: "M371.7,90.5c0.1,1-0.6,1.9-1.5,2l-16.9,2.4c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l16.9-2.4c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L371.7,90.5z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1946",
    className: "disconnect3",
    d: "M407.9,85.4c0.1,1-0.6,1.9-1.5,2L376,91.7c-1,0.1-1.9-0.5-2-1.5c0,0,0,0,0,0l-2.4-16.9 c-0.1-1,0.6-1.9,1.5-2l30.3-4.2c1-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0L407.9,85.4z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1947",
    className: "disconnect3",
    d: "M206.2,206.9c0.1,1,1.1,1.7,2,1.5l108.5-15.2c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1-1.7-2-1.5c0,0,0,0,0,0l-108.5,15.2c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L206.2,206.9z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1948",
    className: "disconnect3",
    d: "M320.4,190.9c0.1,1,1.1,1.7,2,1.5l24.8-3.5c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-24.8,3.5c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L320.4,190.9z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1949",
    className: "disconnect3",
    d: "M351,186.6c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L351,186.6z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_265",
    className: "disconnect3",
    d: "M374.8,174.6l10.3-1.4c1.3-0.2,2.4,0.7,2.6,2l0.8,5.7c0.2,1.3-0.7,2.4-2,2.6l-10.3,1.4 c-1.3,0.2-2.4-0.7-2.6-2l-0.8-5.7C372.7,176,373.5,174.8,374.8,174.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_266",
    className: "disconnect3",
    d: "M390.8,172.4l10.3-1.4c1.3-0.2,2.4,0.7,2.6,2l0.8,5.7c0.2,1.3-0.7,2.4-2,2.6l-10.3,1.4 c-1.3,0.2-2.4-0.7-2.6-2l-0.8-5.7C388.7,173.7,389.6,172.6,390.8,172.4z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1950",
    className: "disconnect3",
    d: "M388.2,170.4c0.2,0.9,1.1,1.6,2,1.4l11.3-1.6c1-0.1,1.7-1,1.6-1.9l-0.9-6.2 c-0.2-0.9-1.1-1.6-2-1.4l-11.3,1.6c-1,0.1-1.7,1-1.6,1.9L388.2,170.4z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_267",
    className: "disconnect3",
    d: "M406.9,170.2l10.3-1.4c1.3-0.2,2.4,0.7,2.6,2l0.8,5.7c0.2,1.3-0.7,2.4-2,2.6l-10.3,1.4 c-1.3,0.2-2.4-0.7-2.6-2l-0.8-5.7C404.7,171.5,405.6,170.3,406.9,170.2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1951",
    className: "disconnect3",
    d: "M406.6,89.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0l2.4,16.9c0.1,1,1.1,1.7,2,1.5 l4.7-0.7l3,21.1c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l10.4-1.5c1-0.1,1.7-1.1,1.5-2l-3.2-22.9l-0.5-3.9l-1.8-13 C408.5,90,407.6,89.3,406.6,89.5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1952",
    className: "disconnect3",
    d: "M367.8,114c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5L367,95c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L367.8,114z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1953",
    className: "disconnect3",
    d: "M345.1,117.2c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L345.1,117.2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1954",
    className: "disconnect3",
    d: "M322.4,120.3c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L322.4,120.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1955",
    className: "disconnect3",
    d: "M299.7,123.5c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L299.7,123.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1956",
    className: "disconnect3",
    d: "M277,126.7c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L277,126.7z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1957",
    className: "disconnect3",
    d: "M254.3,129.9c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L254.3,129.9z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1958",
    className: "disconnect3",
    d: "M332.1,142.3c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L332.1,142.3z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1959",
    className: "disconnect3",
    d: "M354.8,139.1c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L354.8,139.1z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1960",
    className: "disconnect3",
    d: "M377.5,136c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L377.5,136z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1961",
    className: "disconnect3",
    d: "M309.4,145.5c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L309.4,145.5z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1962",
    className: "disconnect3",
    d: "M286.7,148.7c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L286.7,148.7z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1963",
    className: "disconnect3",
    d: "M241.3,155c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1-1.7-2-1.5c0,0,0,0,0,0l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L241.3,155z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1964",
    className: "disconnect3",
    d: "M361.7,161.5c0.1,1,1.1,1.7,2,1.5l52.1-7.3c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-52.1,7.3c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L361.7,161.5z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1965",
    className: "disconnect3",
    d: "M339,164.6c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L339,164.6z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1966",
    className: "disconnect3",
    d: "M316.3,167.8c0.1,1,1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L316.3,167.8z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1967",
    className: "disconnect3",
    d: "M293.6,171c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L293.6,171z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1968",
    className: "disconnect3",
    d: "M270.9,174.2c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L270.9,174.2z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1969",
    className: "disconnect3",
    d: "M248.2,177.3c0.1,1,1.1,1.7,2,1.5l16.9-2.4c1-0.1,1.7-1.1,1.5-2l-2.4-16.9 c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L248.2,177.3z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1970",
    className: "disconnect3",
    d: "M225.5,180.5c0.1,1,1,1.7,2,1.5c0,0,0,0,0,0l16.9-2.4c1-0.1,1.7-1,1.5-2c0,0,0,0,0,0 l-2.4-16.9c-0.1-1-1.1-1.7-2-1.5l-16.9,2.4c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0L225.5,180.5z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1971",
    className: "disconnect3",
    d: "M41.5,239.9c0.2,1,1.1,1.6,2.1,1.4l16.8-3.2c1-0.2,1.6-1.1,1.4-2.1c0,0,0,0,0,0l-3.2-16.8 c-0.2-1-1.1-1.6-2.1-1.4c0,0,0,0,0,0L39.7,221c-1,0.2-1.6,1.1-1.4,2.1c0,0,0,0,0,0L41.5,239.9z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_268",
    className: "disconnect3",
    d: "M335.8,213.9l16.1-0.9c1.3-0.1,2.4,0.9,2.4,2.2l0,0l0.9,16.1c0.1,1.3-0.9,2.4-2.2,2.4 l-16.1,0.9c-1.3,0.1-2.4-0.9-2.4-2.2l-0.9-16.1C333.5,215.1,334.5,214,335.8,213.9z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1972",
    className: "disconnect3",
    d: "M100.1,18.8c0.1,1-0.7,1.9-1.7,1.9c0,0,0,0,0,0l-17.1,1c-1,0.1-1.8-0.7-1.9-1.7l-1-17.1 c-0.1-1,0.7-1.8,1.7-1.9c0,0,0,0,0,0l17.1-1c1-0.1,1.9,0.7,1.9,1.7c0,0,0,0,0,0L100.1,18.8z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1973",
    className: "disconnect4",
    d: "M106.4,201.2l-4.4,9.2l-3.7,7.9l1,11.9l22.4,9.4l16.1-0.3l6.8-10.3l13.4-20.4l6.5-5.2 l15.1-3.8l18.8-7.3l19.8-10.6l11.1-5.4l14-13.2l12.5-6.8l3.2-4.2l-0.7-6.8l-0.6-2.4l0-6.5l-5.3-6.2l-6.4-2l-2-4.1l2.2-5.9 l-5.3-5.9l-35.9-17.1l-5-5.6l-8.8-4.9l-12.2,2.7l-8,14.4l-16.3,26l-19.5,31.3l-15.3,21.9L106.4,201.2z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1974",
    className: "disconnect5",
    d: "M106.4,201.2l-4.4,9.2l15-21.9l21.9-25.1l9.8-17.7l15.9-21.7l14.2-29.7l14.8-8.4l-2.4-1.3 l-12.2,2.7l-8,14.4l-16.3,26l-19.5,31.3l-15.3,21.9L106.4,201.2z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1975",
    className: "disconnect5",
    d: "M129.1,202.6l26.5-15.7l34.8-10l28.2-12.6l-17.6-0.6l-19.9,6.7l-9.6-4l5.3-19.3l0.6-21.9 l-10.8,26.5c0,0-20.2,24.1-20.5,24.6S129.1,202.6,129.1,202.6"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1976",
    className: "disconnect6",
    d: "M258.5,145.3l1.2,7.1l-3.2,4.2l-12.5,6.8l-14,13.2l-11.1,5.4l-19.8,10.6l-18.8,7.3 l-15.1,3.8l-12.2,3.4l-26.3,22.6l16-19.7l30.1-20.2l33.9-9.1l15.6-11.3l14.1-6.3l15.4-7.5L258.5,145.3z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1977",
    className: "disconnect7",
    d: "M164.6,203.5l-6.5,5.2L144.7,229l-6.8,10.3l-16.1,0.3l4.4-10.1l26.3-22.6L164.6,203.5z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1978",
    className: "disconnect7",
    d: "M217.9,127.9l-1.5,4.2l-5.3,1.1L207,133l-4.3,2.2l-2.8,4.8l-1.9,3.3l1-2.8l1.2-4.6 l-1.5-5.9l-2.4-4.2l9.2,1.4l5.1-4.5L217.9,127.9z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1979",
    className: "disconnect6",
    d: "M198,143.3l4.7-8.1l-2.7-6l9,0.1l3.4-4.4l5.4,3l11.3-2.9l-10.1,0.4l-6-3.3l-4.5-10.2 l-0.8,12.6l-6,1.6l-8.9-7.5l6.7,15.3L198,143.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1980",
    className: "disconnect6",
    d: "M244.1,124.1l2.2,2.3l2.7,2.8l-2.2,5.7l-3.7,1.4l-6.8,8.6l-10,5.8l8.1-7.7l3.8-15.7 l2.6-1.4L244.1,124.1z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1981",
    className: "disconnect7",
    d: "M244.1,124.1l2.2,2.3l-4.2,5.3l-7.3,12.3l2.7-12.1l3.3-6L244.1,124.1z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1982",
    className: "disconnect6",
    d: "M200.1,89.7l5,5.6l35.9,17.1l5.3,5.9l-2.2,5.9l-2.2,3.3l-7.1,16.6l-8.6,6.6l-21.9-1.8 l-6.4-5.5l17.7,3.2l16.9-3.5l3.6-16.6l4.1-7.4l-8.6-7.7l-24.9-6.3l-7.6-7.2l-3-10.2L200.1,89.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.653b03875028e0a87b5efb2a3cec13be.svg";
export { ForwardRef as ReactComponent };